import React from 'react';
import OwlCarousel from 'react-owl-carousel';

const Slider = props => (
  <div className="business-main-slider">
    <OwlCarousel className="owl-carousel main-slider" items={1} dots={false} loop autoplay margin={0}>
      {props.slides.map(slider => (
        <div className="item" key={slider.bgImg}>
          <div className="hvrbox">
            <img src={slider.bgImg} alt={slider.ctaTitle} className="hvrbox-layer_bottom" />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3
                    data-animation-in="slideInDown"
                    data-animation-out="animate-out slideOutUp"
                    style={{ color: '#eb4955', backgroundColor: '#000', padding: '4px 8px', display: 'inline' }}
                  >
                    {slider.category}
                  </h3>
                  <h2
                    data-animation-in="slideInDown"
                    data-animation-out="animate-out slideOutUp"
                    style={{ color: '#fff', backgroundColor: '#000', padding: '8px 12px' }}
                  >
                    {slider.title}
                  </h2>
                  {/* <p data-animation-in="slideInLeft" data-animation-out="animate-out fadeOut">
                    {slider.desc}
                  </p> */}
                  <a
                    href={slider.cta}
                    className="bussiness-btn-larg"
                    data-animation-in="slideInUp"
                    data-animation-out="animate-out slideOutDown"
                  >
                    {slider.ctaTitle}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </OwlCarousel>
  </div>
);

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.js